import { createSelector } from 'selectors'

import { constants } from './mermaid.constant'

export const getMermaids = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: constants.selector.root }, true)
